// extracted by mini-css-extract-plugin
export var body = "styles-module--body--170e9";
export var heading = "styles-module--heading--8e8d9";